import { useUpdateSettlementPreferencesMutation } from "../api/SettlementPreferences";

export function useUpdateSettlementPreferences() {
  const [
    updateSettlementPreferences,
    {
      isLoading: isUpdateSettlementPreferencesLoading,
      isError: isUpdateSettlementPreferencesError,
    },
  ] = useUpdateSettlementPreferencesMutation();

  return {
    updateSettlementPreferences,
    isUpdateSettlementPreferencesLoading,
    isUpdateSettlementPreferencesError,
  };
}
